const projects = [
  {
    id: "dayz-mods",
    title: "DayZ Mods",
    description:
      "Custom modifications for DayZ with over 6M+ total subscribers across Steam Workshop. Includes base-building systems, vehicle mechanics, and gameplay enhancements.",
    tags: ["Game Development", "Enforce Script", "3D Modeling"],
    path: "/projects/dayz-mods",
  },
  {
    id: "project-luna",
    title: "Project Luna",
    description:
      "Project Luna is a solo Unreal Engine 5 project designed to push my understanding of the engine. The project primarily used C++ programming and selective use of blueprints for specific functionalities.",
    tags: ["Unreal Engine 5", "C++", "Game Development"],
    path: "/projects/luna",
  },
  {
    id: "project-unicorn",
    title: "Project Unicorn",
    description:
      "Project Unicorn is a digital card game developed in Unreal Engine, inspired by the popular game Unstable Unicorns. This project was created for educational purposes to showcase my skills.",
    tags: ["Unreal Engine 5", "C++", "Game Development"],
    path: "/projects/unicorn",
  },
  {
    id: "project-portfolio",
    title: "flobot.dev",
    description:
      "My portfolio website built with React to showcase my skills, projects, and experience in game development and web applications.",
    tags: ["React", "JavaScript", "Web Development"],
    path: "/projects/portfolio",
  },
];

export default projects;
